export default __webpack_public_path__ + "static/media/ic_drawer_handle.c75d1e87.svg";